import React from 'react';
import styled from 'styled-components';
import { StyledRteTheme } from './style/StyledRteTheme';

export const StyledRteFooter = styled.div`
  min-height: 0px;
  padding-top: 4px;
  border-top: 1px solid ${StyledRteTheme.colorBorder};
  font-size: 12px;
  /* border-top: 1px solid
    ${props => props.theme.colorBorder ?? StyledRteTheme.colorBorder}; */
  &.rte-footer-block {
    + .rte-footer-block {
      margin-top: 4px;
    }
  }
`;
export interface IRichTextFooterItemProps {
  children?: React.ReactNode;
}

export function RichTextFooterItem(props: IRichTextFooterItemProps) {
  const { children } = props;
  if (!children) return null;
  return (
    <StyledRteFooter className="rte-footer-block">{children}</StyledRteFooter>
  );
}
